import React from "react";
import {
  ChartBarIcon,
  UsersIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";

export interface MenuItem {
  key: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

export const appConfig = {
  name: "FancyPeter",
  description: "AI驱动增长服务商",
  icon: {
    gradient: "from-indigo-500 to-purple-600",
  },
};

export const menuItems: MenuItem[] = [
  {
    key: "dashboard",
    icon: ChartBarIcon,
    label: "仪表板",
  },
  {
    key: "users",
    icon: UsersIcon,
    label: "用户管理",
  },
  {
    key: "settings",
    icon: Cog6ToothIcon,
    label: "系统设置",
  },
];

export function getMenuItems(t: (key: string) => string): MenuItem[] {
  return [
    {
      key: "dashboard",
      icon: ChartBarIcon,
      label: t("nav:dashboard"),
    },
    {
      key: "users",
      icon: UsersIcon,
      label: t("nav:userManagement"),
    },
    {
      key: "settings",
      icon: Cog6ToothIcon,
      label: t("nav:settings"),
    },
  ];
}
